/** @jsx jsx */
import { jsx } from '@emotion/react'
import { calendarioEscolarStyle } from '../assets/styles/CalendarioEscolar.styles'
import { Col, Container, Row } from 'react-bootstrap'

const CalendarioEscolar = () => {
  return (
    <section id='sobre' css={calendarioEscolarStyle}>
      <Container>
        <Row data-aos="fade-down" data-aos-delay="500" className='title-sec'>
            <Col lg={6} md={6} sm={12}>
              <h2>Calendário Escola <span>Árabe Bertoni</span></h2>
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={5} md={5} sm={12}>
              <p>Acompanhe datas importantes, celebrações e atividades que fazem parte da vida escolar e da tradição cultural da nossa comunidade.</p>
            </Col>
          </Row>
      </Container>
    </section>

  )
}

export default CalendarioEscolar;
